module.exports = __webpack_public_path__ + "static/media/808ColumnLabel--2.fc5f4088.svg";